export var slide = 'mb-14 flex justify-center items-center';
export var swiperContainer = 'py-3';
export var card = 'bg-white shadow-lg drop-shadow-lg rounded-2xl text-black max-w-27';
export var imageWrapper = 'h-bannerimage w-full';
export var cardBanner = 'h-full w-full rounded-t-lg object-cover';
export var cardTitle = 'mt-4 text-textDark text-left text-2xl font-bold';
export var cardText = 'text-textMid text-left text-base';
export var statusChip = 'mt-4 mb-1.5';
export var cardInformation = 'bg-uiBg px-4 pb-5 flex flex-col justify-space-between items-start overflow-hidden h-48 sm-mobile:h-8.75';
var dot = 'h-2.5 inline-block rounded-full m-2';
export var paginationItem = "".concat(dot, " w-2.5 bg-secondaryAccent2");
export var activePaginationItem = "".concat(dot, " w-5 bg-secondary");
//# sourceMappingURL=header-slider.styles.js.map